import { GridColDef } from "@mui/x-data-grid";

export const columnsConfig: Record<string, GridColDef[]> = {
    npaReport: [
        { field: "loanId", headerName: "Loan ID", flex: 1 },
        { field: "applicantName", headerName: "Name", flex: 1 },
        { field: "mobile", headerName: "Contact", flex: 1 },
        { field: "lastRepaymentDate", headerName: "Last Repayment", flex: 1 },
        { field: "amountSanctioned", headerName: "Sanctioned Amount", flex: 1 }
    ],

    interestReport: [
        { field: "loanId", headerName: "Loan ID" },
        {
            field: "applicantName",
            headerName: "Entrepreneur(s)",
        },
        { field: "mobile", headerName: "Phone Number" },
        { field: "whatsappNumber", headerName: "WhatsApp Number" },
        { field: "enterpriseName", headerName: "Enterprise" },
        { field: "nhgMemberName", headerName: "NHG Member" },
        { field: "sanctionedAmount", headerName: "Sanctioned CEF", },
        { field: "nhgName", headerName: "NHG" },
        { field: "adsName", headerName: "ADS" },
        { field: "cdsName", headerName: "CDS" },
        { field: "totalInterest", headerName: "Total Interest Received", },
    ],
    principalReport: [
        { field: "loanId", headerName: "Loan ID", flex: 1 },
    {
        field: "applicantName",
        headerName: "Entrepreneur(s)",
        flex: 1.5,
    },
    { field: "mobile", headerName: "Phone", flex: 1 },
    { field: "whatsappNumber", headerName: "WhatsApp", flex: 1 },
    { field: "enterpriseName", headerName: "Enterprise", flex: 1 },
    { field: "nhgMemberName", headerName: "NHG Member", flex: 1 },
    { field: "nhgName", headerName: "NHG", flex: 1 },
    { field: "adsName", headerName: "ADS", flex: 1 },
    { field: "cdsName", headerName: "CDS", flex: 1 },
    {
        field: "sanctionedAmount",
        headerName: "Sanctioned Amount",
        type: "number",
        flex: 1,
    },
    {
        field: "totalPrincipal",
        headerName: "Total Principal Received",
        type: "number",
        flex: 1,
    },],
    loanStatement: [
        { field: "loanId", headerName: "Loan ID", flex: 1 },
        {
            field: "applicantName",
            headerName: "Entrepreneur(s)",
            flex: 1.5,
        },
        { field: "mobile", headerName: "Phone", flex: 1 },
        { field: "whatsappNumber", headerName: "WhatsApp", flex: 1 },
        { field: "enterpriseName", headerName: "Enterprise", flex: 1 },
        { field: "sanctionedAmount", headerName: "Sanctioned Amount", flex: 1, type: "number" },
        { field: "repaymentDate", headerName: "Repayment Date", flex: 1 },
        {
            field: "principalComponent",
            headerName: "Principal",
            type: "number",
            flex: 1,
        },
        {
            field: "interestComponent",
            headerName: "Interest",
            type: "number",
            flex: 1,
        },
        {
            field: "amount",
            headerName: "Total Paid",
            type: "number",
            flex: 1,
        },
        {
            field: "receiptNumber",
            headerName: "Receipt No.",
            flex: 1,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            flex: 1,
        },
    ],

    loanSanction: [{ field: "loanId", headerName: "Loan ID", flex: 1 },
    {
        field: "applicantName",
        headerName: "Entrepreneur(s)",
        flex: 1.5,
    },
    { field: "enterpriseName", headerName: "Enterprise", flex: 1 },
    { field: "sanctionDate", headerName: "Sanction Date", flex: 1 },
    {
        field: "sanctionedAmount",
        headerName: "Sanctioned Amount",
        type: "number",
        flex: 1,
    },
    { field: "nhgMemberName", headerName: "NHG Member", flex: 1 },
    { field: "nhgName", headerName: "NHG", flex: 1 },
    { field: "adsName", headerName: "ADS", flex: 1 },
    { field: "cdsName", headerName: "CDS", flex: 1 },
    { field: "blockName", headerName: "Block", flex: 1 },
    { field: "districtName", headerName: "District", flex: 1 },]
};